// Floating header: sets data-scrolled on [data-floating-header] once the page leaves the top,
// so the glass pill can switch to a solid white fill. Passive scroll + rAF keeps it cheap.
//
// Phones (under 768px): when scrolled, the header icons ([data-header-collapse]) fade out and the
// logo ([data-header-logo]) glides to the centre of the pill. The shift is measured here and passed
// to CSS as --logo-shift so the transform animates smoothly.
//
// Also sets data-scroll-dir="down|up" on <html>; CSS uses it to tuck the Shopify Inbox chat button
// away while the shopper scrolls down and bring it back when they scroll up.
const header = document.querySelector('[data-floating-header]');
const root = document.documentElement;
const mobile = window.matchMedia('(max-width: 767px)');

if (header) {
  const pill = header.querySelector('[data-header-nav-group]');
  const logo = header.querySelector('[data-header-logo]');
  let ticking = false;
  let lastY = window.scrollY;

  const measureShift = () => {
    if (!pill || !logo) return;
    if (!mobile.matches) {
      logo.style.removeProperty('--logo-shift');
      return;
    }
    // offsetLeft/offsetWidth ignore transforms, so this is the un-shifted layout position even mid-animation.
    // The pill is position: relative, so it is the logo wrapper's offsetParent.
    let left = 0;
    for (let el = logo; el && el !== pill; el = el.offsetParent) left += el.offsetLeft;
    const shift = pill.clientWidth / 2 - (left + logo.offsetWidth / 2);
    logo.dataset.shift = `${Math.round(shift)}px`;
  };

  const update = () => {
    const y = window.scrollY;
    const scrolled = y > 12;
    header.toggleAttribute('data-scrolled', scrolled);
    if (logo) logo.style.setProperty('--logo-shift', scrolled && mobile.matches ? logo.dataset.shift || '0px' : '0px');

    if (Math.abs(y - lastY) > 6) {
      root.dataset.scrollDir = y > lastY && y > 80 ? 'down' : 'up';
      lastY = y;
    }
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );

  // Shopify Inbox chat: the app injects its own element (name not guaranteed), so find it at runtime
  // among <body>'s direct children by an id, class or tag containing "chat", and hide it on phones
  // whenever the page is scrolled so it never covers the bottom nav.
  const chatHosts = new Set();
  const isChatHost = (el) =>
    el instanceof HTMLElement &&
    !el.matches('script, style, link, dialog, [data-floating-header], .mobile-nav') &&
    /chat|inbox/i.test(`${el.id} ${el.tagName} ${el.className}`);
  const syncChat = () => {
    const hide = mobile.matches && window.scrollY > 12;
    chatHosts.forEach((el) => {
      if (!el.isConnected) return chatHosts.delete(el);
      el.style.setProperty('transition', 'opacity 0.3s ease, visibility 0s linear ' + (hide ? '0.3s' : '0s'));
      el.style.setProperty('opacity', hide ? '0' : '');
      el.style.setProperty('visibility', hide ? 'hidden' : '');
      el.style.setProperty('pointer-events', hide ? 'none' : '');
    });
  };
  const collectChat = () => {
    for (const el of document.body.children) if (isChatHost(el)) chatHosts.add(el);
    syncChat();
  };
  new MutationObserver(collectChat).observe(document.body, { childList: true });
  collectChat();
  window.addEventListener('scroll', () => requestAnimationFrame(syncChat), { passive: true });
  mobile.addEventListener('change', syncChat);

  const remeasure = () => {
    measureShift();
    update();
  };
  window.addEventListener('resize', remeasure, { passive: true });
  mobile.addEventListener('change', remeasure);
  if (document.fonts?.ready) document.fonts.ready.then(remeasure);
  remeasure();
}
